<template>
    <i @click="$emit('c-click')" class="el-icon-refresh cursor-pointer"></i>
</template>
<script>
    export default {
    }
</script>
